import { render, staticRenderFns } from "./attachmentListOld.vue?vue&type=template&id=3a72ae5f&"
import script from "./attachmentListOld.vue?vue&type=script&lang=js&"
export * from "./attachmentListOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports